'use client';

import { CallOffOrderColor, QuotedColor } from '@ravago/shared/page-data/models/elements';
import { LeadTimeIndicator } from '@ravago/shared/page-data/models/elements/product-lead-time.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { isCallOffOrderColor, isQuotedColor } from '../../utils/order-now-utils';

import { DynamicProductBlockCallOffFields } from './dynamic-product-block-call-off-fields';
import { DynamicProductBlockQuotedColorFields } from './dynamic-product-block-quoted-color-fields';
import { OrderNowSelector } from './order-now-selector';

interface Props {
   callOffOrderColors: CallOffOrderColor[];
   quotedColors: QuotedColor[];
   leadTimeIndicators: LeadTimeIndicator[];
   selected: CallOffOrderColor | QuotedColor | undefined;
   selectedLineId: string | undefined;
   quantityAmount: number | undefined;
   leadTimeEnabled: boolean;
   usesAgreementApp: boolean;
   onSelectedChange: (value: CallOffOrderColor | QuotedColor) => void;
   onSelectedLineChange: (selectedLineId: string) => void;
   onQuantityAmountChange: (quantityAmount: number | undefined) => void;
}

export const OrderNow = ({
   callOffOrderColors,
   quotedColors,
   leadTimeIndicators,
   selected,
   selectedLineId,
   quantityAmount,
   leadTimeEnabled,
   usesAgreementApp,
   onSelectedChange,
   onSelectedLineChange,
   onQuantityAmountChange
}: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         <Box direction="column" gap="sm">
            {callOffOrderColors.length + quotedColors.length > 1 && (
               <Typography variant="body-highlight" id="select-quantity-label">
                  {translate('dynamic-product-block.select-option')}
               </Typography>
            )}
            <OrderNowSelector callOffOrderColors={callOffOrderColors} quotedColors={quotedColors} value={selected} onChange={onSelectedChange} />
         </Box>

         {selected && isCallOffOrderColor(selected) && (
            <DynamicProductBlockCallOffFields
               id="dynamic-product-block-call-off-fields"
               quantityAmount={quantityAmount}
               callOffOrderColor={selected}
               onQuantityAmountChanged={onQuantityAmountChange}
               usesAgreementApp={usesAgreementApp}
            />
         )}

         {selected && isQuotedColor(selected) && (
            <DynamicProductBlockQuotedColorFields
               quotedColor={selected}
               selectedLineId={selectedLineId}
               leadTimeIndicators={leadTimeIndicators}
               leadTimeEnabled={leadTimeEnabled}
               onSelectedLineChange={onSelectedLineChange}
            />
         )}
      </Box>
   );
};
